import { render, staticRenderFns } from "./programDetail.vue?vue&type=template&id=0c467760&"
import script from "./programDetail.vue?vue&type=script&lang=js&"
export * from "./programDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports